
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <router-link :to="{ path: '/administracion/roles/nuevo'}" replace>
            <button  type="button"   class="btn btn-primary">Nuevo Rol</button>
        </router-link>
        <vue-good-table
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-search="onSearch"
                :totalRows="totalRecords"
                :isLoading.sync="isLoading"
                :pagination-options="{
                    enabled: true,
                    }"
                :rows="rows"
                :columns="columns"
                :globalSearch="true"
                @on-row-dblclick="onRowDoubleClick"
                styleClass="vgt-table striped smalltable"
                :search-options="{
                    enabled: true,
                    //trigger: 'enter',
                    skipDiacritics: true,
                    placeholder: 'buscarEnTabla',
                  }"

        >
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'acciones'">
                <router-link :to="{path:'/administracion/roles/ver/'+props.row.id}" v-if="$can('roles-ver')">
                    <button class="btn btn-success btn-icon btn-sm mr-1"><i class="fa fa-eye"></i></button>
                </router-link>
                <router-link :to="{path:'/administracion/roles/'+props.row.id}"  v-if="$can('roles-edicion')">
                    <button class="btn btn-primary btn-icon btn-sm"><i class="fa fa-edit"></i></button>
                </router-link>
                <button v-if="$can('roles-edicion')" class="btn btn-danger btn-icon btn-sm ml-1" v-on:click="borrar(props.row.id)" ><i class="fa fa-trash"></i></button>
                <!--<span style="font-weight: bold; color: blue;">{{props.row.age}}</span>-->
            </span>
                <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
            </template>
        </vue-good-table>
    </Layout>
</template>


<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";

    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Roles",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: {
            Layout,
            PageHeader,
        },
        data() {
            return {
                title: "Roles",
                items: [
                    {
                        text: "Administración",
                        href: "/",
                    },
                    {
                        text: "Roles",
                        active: true,
                    },
                ],

                isLoading: false,
                columns: [
                    {
                        label: 'id',
                        field: 'id',
                    },
                    {
                        label: 'Nombre',
                        field: 'name',
                    },

                    {
                        label: 'Acciones',
                        field: 'acciones',
                        width:'12%'
                    }


                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {
                    },
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                }

            };
        },

        methods: {
            decimal(value)
            {
                if (value===null)
                {
                    return '-'
                }
                else
                {
                    return parseFloat(value).toFixed(2)
                }


            },
            borrar(id)
            {
                this.$swal.fire({
                    title: '¿Esta seguro?',
                    text: "No se puede revertir esta accion!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Si, borralo!'
                }).then((result) => {
                    if (result.value) {
                        this.isLoading=true;
                        this.axios.delete(process.env.VUE_APP_BACKEND +'/api/usuarios/'+id)
                            .catch(()=>{
                                this.$swal('error','Error eliminando','error');
                            })
                            .finally(
                                ()=>
                                {
                                    this.isLoading=false;
                                    this.loadItems();
                                }

                            );
                    }
                })

            },
            onSearch :function(params)
            {
                this.updateParams({page: params.page});
                this.updateParams({searchTerm: params.searchTerm});
                this.loadItems();
            },
            say: function (message) {
                alert(message)
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            // load items is what brings back the rows from server
            loadItems() {

                this.isLoading=true;
                this.axios.get( process.env.VUE_APP_BACKEND+'/api/roles/tabla',{'params':this.serverParams})
                    .then( (response) =>{
                        //console.log(response.data.data);
                        this.totalRecords = response.data.total_records;
                        this.rows = response.data.data;
                        this.isLoading=false;
                    })
                    .catch(() =>{
                        this.isLoading=false;
                        //console.log(error);
                    });
            },
            onRowDoubleClick(params)
            {
                this.$router.push('administracion/roles/'+params.row.id);
            }
        },
        mounted() {
            this.loadItems();
        }
    };
</script>

<style>
    .smalltable{
        font-size: 12px !important;
    }

</style>
